const ITEMS = [
  "Academic Preparation", "Discipline", "Mentorship", "Quality Teaching",
  "Examination Readiness", "University Readiness", "Direct Entry Pathway", "Personal Development",
];

export function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="relative overflow-hidden border-y border-[#D4AF37]/30 bg-[#0A1E4E] py-5" data-testid="editorial-marquee">
      <div className="flex w-max animate-marquee whitespace-nowrap">
        {row.map((t, i) => (
          <span key={i} className="mx-6 inline-flex items-center gap-6 font-serif text-2xl sm:text-3xl italic text-white/90">
            {t}
            <span className="text-[#D4AF37] text-xl not-italic">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
